export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-bitcoin-064894ad0eb4ad89c85d715082864b3e.svg";